import Modal from './Modal';

export default Modal;



// WEBPACK FOOTER //
// ./src/components/atoms/Modal/index.js